export const isMobileNumberValid = (number) => {
  const ukNumberRegex = /^(?:07\d{8,12}|447\d{7,11}|\+447\d{7,11}|0(?:1|2|3)\d{8,9}|\+44(?:1|2|3)\d{8,9})$/;
  return ukNumberRegex.test(number);
};

export const NumberIsUKFormat = (number) => {
  if (!number || typeof number !== "string") {
    return false;
  }

  const normalized = number.replace(/[^\d+]/g, "");
  const uk07FormatRegex = /^07\d{9}$/;
  const ukPlus44FormatRegex = /^\+44\d{10}$/;

  if (uk07FormatRegex.test(normalized) || ukPlus44FormatRegex.test(normalized)) {
    return true;
  }

  return false;
};
